/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React } from "react";

import { Spin } from "@neonmachine-shrapnel/sds-ui";
import { default as Styles } from "./Loading.module.scss";

const Loading = () => {
  return (
    <div className={Styles.loadingContainer}>
      <div className={Styles.loadingFlag}>
        <Spin width={250} height={250} loadingText="Please wait..." textPosition="bottom" />
      </div>
    </div>
  );
};

export default Loading;
